export const editorConfig = {
  askBeforePasteHTML: false,
  askBeforePasteFromWord: false,
  events: {
    afterInit: function (editor) {
      function removeStyleAttributes() {
        const elements = editor.editor.querySelectorAll('*');
        elements.forEach(element => {
          element.removeAttribute('style');
        });
      }

      function addNoFollowToLinks() {
        const links = editor.editor.querySelectorAll('a');
        links.forEach(link => {
          link.setAttribute('target', '_blank');
          link.setAttribute('rel', 'nofollow noopener noreferrer');
        });
      }

      function removeRefAttributes() {
        const elements = editor.editor.querySelectorAll('[ref]');
        elements.forEach(element => {
          element.removeAttribute('ref');
        });
      }

      editor.events.on('paste', () => {
        addNoFollowToLinks();
        removeRefAttributes();
        removeStyleAttributes();
      });
      editor.events.on('change', () => {
        addNoFollowToLinks();
        removeRefAttributes();
        removeStyleAttributes();
      });
      editor.events.on('afterInsertLink', () => {
        addNoFollowToLinks();
        removeRefAttributes();
        removeStyleAttributes();
      });
    },
  },
};

export const selectStyles = {
  menu: baseStyles => ({
    ...baseStyles,
    zIndex: 10,
  }),
  input: baseStyles => ({
    ...baseStyles,
    height: '58px',
  }),
  control: baseStyles => ({
    ...baseStyles,
    border: 'none',
  }),
  container: baseStyles => ({
    ...baseStyles,
    fontSize: '17px',
    borderRadius: '6px',
    border: '1px dashed #a7a6a6',
  }),
  valueContainer: baseStyles => ({
    ...baseStyles,
    paddingLeft: '20px',
  }),
};
